export default __webpack_public_path__ + "3dec24a5814a7044e479fb5ad0a3bea5.png";